export default function FlowPaySwitch({ checked, onChange }) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            onClick={() => onChange(!checked)}
            className={`relative inline-flex h-4 w-7 shrink-0 cursor-pointer items-center rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--purple)]/30 focus:ring-offset-0 ${
                checked
                    ? 'bg-[var(--purple)] hover:brightness-110'
                    : 'border border-white/[0.06] bg-white/[0.08] hover:bg-white/[0.12]'
            }`}
        >
            <span
                className={`pointer-events-none block h-3 w-3 rounded-full bg-white shadow-sm transition-transform duration-200 ${
                    checked ? 'translate-x-[14px]' : 'translate-x-0.5'
                }`}
            />
        </button>
    );
}
